(function() {
    'use strict';

    angular.module('blocks.l10n', ['pascalprecht.translate', 'tmh.dynamicLocale', 'ngCookies']);
})();
